import { ConnectFlowCustomModel, DefaultServiceResult } from '@/types';

export interface ConnectFlowCustomServiceGetAllParams {
    page?: number;
    per_page?: number;
    order_by?: string;
    is_active?: boolean;
    search?: string;
}

export interface ConnectFlowCustomServiceCreateResult extends DefaultServiceResult {
    result: ConnectFlowCustomModel;
}
